import React, { useEffect, useState, useRef } from 'react';
const services = [{
  number: '01',
  title: 'Senior-level talent, on demand',
  description: 'Drop us into your team. We operate at the level of your best senior designers — without the hiring overhead, ramp time, or equity dilution.',
  color: 'var(--blue)'
}, {
  number: '02',
  title: '0 to 1 specialists',
  description: 'We specialize in the hardest part of product development: going from nothing to something real. Product definition, user flows, design systems, and handoff.',
  color: 'var(--pink)'
}, {
  number: '03',
  title: 'AI-accelerated',
  description: 'We use Claude, Cursor, Lovable, and Magic Patterns to move faster without sacrificing quality. The best tools in the hands of experienced designers.',
  color: 'var(--orange)'
}];
function ServiceCard({
  service,
  index
}: {
  service: (typeof services)[0];
  index: number;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className="py-8 border-b transition-all duration-700 ease-out" style={{
    borderColor: 'var(--border)',
    opacity: visible ? 1 : 0,
    transform: visible ? 'translateY(0)' : 'translateY(20px)',
    transitionDelay: `${index * 80}ms`
  }} data-id="element-63">
      <div className="flex gap-6 sm:gap-10 items-start" data-id="element-64">
        <span className="flex-shrink-0 w-6" style={{
        color: service.color,
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-body)',
        fontWeight: '600'
      }} data-id="element-65">
          {service.number}
        </span>
        <div className="flex-1 flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-10" data-id="element-66">
          <h3 className="leading-tight sm:w-64 flex-shrink-0" style={{
          color: 'var(--text)',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-title)',
          fontWeight: '600'
        }} data-id="element-67">
            {service.title}
          </h3>
          <p className="leading-relaxed" style={{
          color: 'var(--text-muted)',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-body)',
          fontWeight: '400'
        }} data-id="element-68">
            {service.description}
          </p>
        </div>
      </div>
    </div>;
}
export function WhatWeDo() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return <section className="py-24 px-6" style={{
    backgroundColor: 'var(--bg)'
  }} data-id="element-69">
      <div className="max-w-6xl mx-auto" data-id="element-70">
        <div ref={ref} className="mb-16 transition-all duration-700 ease-out" style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(16px)'
      }} data-id="element-71">
          <h2 style={{
          color: 'var(--text)',
          fontFamily: 'var(--font-heading)',
          fontSize: 'var(--text-heading)',
          fontWeight: 'normal'
        }} data-id="element-72">
            About us
          </h2>
        </div>
        <div className="border-t" style={{
        borderColor: 'var(--border)'
      }} data-id="element-73">
          {services.map((service, i) => <ServiceCard key={service.number} service={service} index={i} data-id="element-74" />)}
        </div>
      </div>
    </section>;
}